<template>
    <div>
        <div>
            <div :class="['flex', 'bg-[#272727]', 'p-2', 'rounded', 'shadow-md', 'mb-2', 'items-center', result.user_id === user.id ? highlightUser(result) : 'text-white']" :key="result.user_id" v-for="(result, index) in paginatedResults">
                <div class="mr-4"><p class="w-7 text-center rounded-md" :class="getRankColor(getPosition(result, index))">{{ getPosition(result, index) }}</p></div>
                <div class="inline-flex relative w-fit">
                    <div v-if="$page.props.features.exp" class="absolute inline-block top-0 right-0 bottom-auto left-auto translate-x-2/4 -translate-y-1/2 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 py-1 px-2.5 text-xs leading-none text-center whitespace-nowrap align-baseline font-bold rounded-full z-10" :class="result.user_id === user.id ? 'bg-[#272727] text-white' : 'bg-racing-stars-yellow text-gray-800'">Level {{ result.user.level.level }}</div>
                    <div class="shrink-0 h-10 w-10 mr-2">
                        <img class="rounded-full h-10 w-10 object-cover border border-black" :src="result.user.profile_photo_url" />
                    </div>
                </div>
                <div class="flex grow text-sm md:text-base">
                    {{ result.user.username }}
                    <img v-if="$page.props.settings.site_name === 'Racing League'" class="ml-2" :src="asset('images/racingleague/rl-leaderboard-' + result.user.team + '.svg')" :class="[result.user.team === 'scotland' ? 'w-4' : 'w-6']" />
                </div>
                <div class="flex uppercase text-sm md:text-base">{{ result.points }} Points</div>
            </div>
        </div>
        <div class="flex justify-center">
            <v-pagination
                v-model="page"
                v-if="total_pages > 1"
                :pages="total_pages"
                :range-size="1"
                active-color="#fcea0d"
                @update:modelValue="updateHandler"
            />
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
    props: {
        user: {
            type: Object,
            default: {}
        },
        leaderboard: {
            type: Array,
            default: []
        },
    },

    setup(props) {
        const highlightUser = (result) => {
            return result.user_id === props.user.id ? 'bg-racing-stars-yellow text-black' : '';
        };

        return {
            highlightUser,
        }
    },

    data() {
        return {
            page: 1,
            total_pages: 0,
            items_per_page: 10,
        };
    },

    computed: {
        total_pages() {
            console.log("leaderboard : ", this.leaderboard);
            return Math.ceil(this.leaderboard.length/this.items_per_page);
        },

        paginatedResults() {
            return this.getPaginatedResults();
        }
    },

    methods: {
        updateHandler(page) {
            this.page = page;
        },
        getRankColor(rank) {
            if (rank === 1) {
                return 'bg-gold text-black';
            } else if (rank === 2) {
                return 'bg-silver text-black';
            } else if (rank === 3) {
                return 'bg-bronze text-black';
            }
        },
        getPaginatedResults() {
            const start = (this.page - 1) * this.items_per_page;
            const end = start + this.items_per_page;

            let paginated = this.leaderboard.slice(start, end);
            const userInTop10 = this.leaderboard.slice(0, 10).some(user => user.user_id === this.user.id);

            if (!userInTop10 && this.page === 1) {
                const userInLeaderboard = this.leaderboard.find(user => user.user_id === this.user.id);
                if (userInLeaderboard && !paginated.some(user => user.user_id === this.user.id)) {
                    paginated.push(userInLeaderboard);
                }
            }

            return paginated;
        },
        getPosition(result, index) {
            return result.position === null ? index + 1 + ((this.page - 1) * 10) : result.position;
        }
    },

    components: {
        VPagination
    },

}
</script>
<style scoped>
    .bg-gold {
        background-color: gold !important;
    }
  
    .bg-silver {
        background-color: silver !important;
    }
  
    .bg-bronze {
        background-color: #CD7F32 !important;
    }

    .bg-gradient-to-br {
        color: #ffffff;
        font-weight: 500;
    }
</style>